import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve si nunca trabajé con cemento antes?',
  a: 'Es el sistema ideal para cualquier nivel. Si recién empezás, construís todo bien desde cero y evitás los errores caros que arruinan los primeros intentos. Si ya fabricaste algo, ordenás tu proceso, mejorás terminaciones y aprendés a cobrar lo que realmente vale tu trabajo.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Una vez confirmado el pago a través de Mercado Pago, recibís acceso inmediato a los 12 tomos en formato PDF descargable más los 5 bonos. Todo en menos de 5 minutos directamente en tu casilla de correo. Podés leerlo desde el celular, tablet o computadora.'
}, {
  q: '¿Es realmente para el mercado argentino?',
  a: 'Sí, 100%. Todos los proveedores, marcas de materiales, precios de referencia, plataformas de cobro y estrategias de venta están pensadas específicamente para el contexto económico de Argentina en 2026. No vas a encontrar materiales que "no se consiguen acá".'
}, {
  q: '¿Necesito herramientas caras o un taller equipado?',
  a: 'No. El sistema está diseñado para empezar desde la cocina o el patio de tu casa con herramientas simples: un balde, una espátula, un molde y los materiales básicos que conseguís en cualquier corralón. La inversión inicial no supera los $8.000 ARS.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, y es de verdad. Tenés 7 días completos para revisar todo el contenido. Si considerás que no vale lo que pagaste, escribinos y te devolvemos el 100% del dinero sin hacerte ninguna pregunta ni pedirte justificación. Punto.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Preguntas frecuentes" className="bg-ink" data-id="element-51" data-mp="wvt4xldykfyo">
      <div className="mx-auto max-w-3xl px-5 pt-[32px]" data-id="element-52" data-mp="iywhltx1tgmj">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-53" data-mp="n0hpf0uq74pv">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="mt-10 divide-y divide-white/10 overflow-hidden rounded-2xl border border-white/10 bg-ink-2" data-id="element-54" data-mp="2po81brqg7p0n">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-55" data-mp="2fur4sfyxfvta" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-white/[0.03]" data-id="element-56" data-mp="2ay0qny6onaai">
                  <span className="text-sm font-bold text-white sm:text-base" data-id="element-57" data-mp="33klcyk8aww77">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-gold" data-id="element-58" data-mp="2um9gw2oo167d" /> : <PlusIcon className="h-5 w-5 shrink-0 text-cemento" data-id="element-59" data-mp="1n7wj5fqdiqe8" />}
                </button>
                <div className="grid transition-all duration-300 ease-in-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-60" data-mp="1j6bbq9wlz4bf">
                  <div className="overflow-hidden" data-id="element-61" data-mp="2pm2puw9jeg8">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-white/65" data-id="element-62" data-mp="2qdnsbs8hts9">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}